import type { tenant as Tenant } from '@vrplatform/graphql';
import { getCountryByIsoCode } from '../iso-3166';
import { type FormatAddressOptions, formatAddress } from './format-address';

// billing_address_data
// {
//   "city": "Cedar Key",
//   "full": "12619 Florida 24, Cedar Key, Florida, 32625, United States of America",
//   "line1": "12619 Florida 24",
//   "line2": "",
//   "state": "Florida",
//   "stateCode": "FL",
//   "postalCode": "32625",
//   "countryCode": "US"
// }

export const getTenantAddress = (
  tenant: Tenant,
  options?: FormatAddressOptions
) => {
  const json = tenant.billingAddressData() as {
    city: string;
    full: string;
    line1: string;
    line2: string;
    state: string;
    stateCode: string;
    postalCode: string;
    countryCode: string;
  } | null;

  const values: Parameters<typeof formatAddress>[0] = {
    line1: json?.line1 || tenant.addressLine1 || '',
    line2: json?.line2 || '',
    city: json?.city || tenant.addressCity || '',
    postcode: json?.postalCode || tenant.addressPostcode || '',
    state: json?.state || undefined,
    stateCode: json?.stateCode || undefined,
    country:
      getCountryByIsoCode(json?.countryCode ?? '')?.name ||
      tenant.addressCountry,
    countryCode: json?.countryCode || undefined,
  };

  const full = formatAddress(values, options) || tenant.address;

  return {
    values,
    full,
  };
};
